/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

import { useEffect, useRef } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

export default function RichTextEditor({
  value = "",
  onChange = () => {},
  editable = true,
}) {
  const isProgrammaticUpdate = useRef(false);

  const editor = useEditor({
    extensions: [StarterKit],
    content: value || "<p></p>",
    editable,
    onUpdate: ({ editor }) => {
      //if (isProgrammaticUpdate.current) return;
      if (typeof onChange === "function") {
        onChange(editor.getHTML());
      }
    },
  });

  useEffect(() => {
    if (!editor) return;
    editor.setEditable(editable);
  }, [editor, editable]);

//   useEffect(() => {
//     if (!editor) return;

//     const nextValue = value || "<p></p>";
//     if (editor.getHTML() === nextValue) return;

//     isProgrammaticUpdate.current = true;
//     editor.commands.setContent(nextValue, false);
//     isProgrammaticUpdate.current = false;
//   }, [editor, value]);

  if (!editor) return null;

  return (
    <div className="rounded-xl border border-slate-300 dark:border-slate-700 overflow-hidden">
      <EditorToolbar editor={editor} />

      <EditorContent
        editor={editor}
        className="p-4 bg-white dark:bg-slate-900 prose dark:prose-invert max-w-none"
      />
    </div>
  );
}

function EditorToolbar({ editor }) {
  if (!editor) return null;

  const buttonClass =
    "px-2 py-1 rounded-md text-xs font-medium hover:bg-slate-200 dark:hover:bg-slate-700";

  return (
    <div className="flex flex-wrap gap-1 p-2 border-b bg-slate-50 dark:bg-slate-800">
      <button className={buttonClass} onClick={() => editor.chain().focus().toggleBold().run()}>
        Bold
      </button>
      <button className={buttonClass} onClick={() => editor.chain().focus().toggleItalic().run()}>
        Italic
      </button>
      <button className={buttonClass} onClick={() => editor.chain().focus().toggleBulletList().run()}>
        Bullets
      </button>
      <button className={buttonClass} onClick={() => editor.chain().focus().toggleOrderedList().run()}>
        Numbering
      </button>
      <button className={buttonClass} onClick={() => editor.chain().focus().undo().run()}>
        Undo
      </button>
      <button className={buttonClass} onClick={() => editor.chain().focus().redo().run()}>
        Redo
      </button>
    </div>
  );
}